export const SITE = {
  name: "Jordan Martel",
  credential: "RMT",
  pronouns: "He/Him",
  tagline: "Registered Massage Therapy",
  city: "Vancouver, BC",
  email: "jtmartel13@gmail.com",
  instagram: "https://www.instagram.com/rmtjordan/",
  locations: [
    {
      id: "west-end",
      clinic: "West End Physiotherapy",
      area: "West End — Alberni St",
      address: "#303 — 1166 Alberni St, Vancouver, BC V6E 3Z3",
      phone: "(604) 684-0047",
      phoneHref: "tel:+16046840047",
      bookingUrl: "https://westendphysio.janeapp.com/",
      mapEmbed:
        "https://www.google.com/maps?q=1166+Alberni+St,+Vancouver,+BC&output=embed",
      note: "Steps from Burrard SkyTrain, in the heart of the West End.",
    },
    {
      id: "paper-crane",
      clinic: "Paper Crane Massage Therapy",
      area: "East Vancouver — E Hastings St",
      address: "#201 — 2280 E Hastings St, Vancouver, BC",
      phone: "(778) 800-8770 ext. 706",
      phoneHref: "tel:+17788008770",
      bookingUrl: "https://papercranemassage.janeapp.com/",
      mapEmbed:
        "https://www.google.com/maps?q=2280+E+Hastings+St,+Vancouver,+BC&output=embed",
      note: "A cozy, inclusive studio in Hastings-Sunrise.",
    },
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1519823551278-64ac92734fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxtYXNzYWdlJTIwdGhlcmFweSUyMHByb2Zlc3Npb25hbCUyMHNwYXxlbnwwfHx8fDE3ODU1NDM4NzN8MA&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1745327883508-b6cd32e5dde5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxtYXNzYWdlJTIwdGhlcmFweSUyMHByb2Zlc3Npb25hbCUyMHNwYXxlbnwwfHx8fDE3ODU1NDM4NzN8MA&ixlib=rb-4.1.0&q=85",
  texture: "https://images.unsplash.com/photo-1766214272630-42391e217ed0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxjYWxtJTIwemVuJTIwYWJzdHJhY3QlMjB0ZXh0dXJlJTIwbGlnaHR8ZW58MHx8fHwxNzg1NTQzODczfDA&ixlib=rb-4.1.0&q=85",
  vancouver: "https://images.unsplash.com/photo-1576374596670-dc25a5edfb92?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHx2YW5jb3V2ZXIlMjBjaXR5JTIwc3RyZWV0JTIwdHJlZXxlbnwwfHx8fDE3ODU1NDM4NzN8MA&ixlib=rb-4.1.0&q=85",
};
